import React from 'react';

import Text from '/component/base/Text';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';

export const earnedDaysUtil = ({earnedOn, tt}: any) => {
  const dateUtil = getDateUtilDefaultInstance();

  const difference = dateUtil.getDaysToToday(earnedOn);

  if (difference === 0) {
    return tt('EarnedNoDaysPassed', 'today');
  } else if (difference === 1) {
    return tt('EarnedOneDayPassed', 'yesterday');
  } else if (difference <= 5) {
    return tt(
      'earnedDaysPassed',
      generateComponentCallback({
        component: <Text>{Math.abs(difference)} days ago</Text>,
      }),
    );
  }
  return dateUtil.formatDate(earnedOn, 'MMMM d, yyyy');
};
